module.exports = __webpack_public_path__ + "static/media/25-4.ad142e28.mp3";